import { render, staticRenderFns } from "./recorder.vue?vue&type=template&id=476607b2&scoped=true&"
import script from "./recorder.vue?vue&type=script&lang=js&"
export * from "./recorder.vue?vue&type=script&lang=js&"
import style0 from "./recorder.vue?vue&type=style&index=0&id=476607b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476607b2",
  null
  
)

export default component.exports